define('lib/Podio.Transport.Reminder',['require','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  function update(refType, refId, remindDelta, callback) {
    transport.putJSON(routes.reminder_path(refType, refId), {
      'requestData': {
        'remind_delta' : remindDelta
      }
    }, callback);
  }

  function destroy(refType, refId, callback) {
    transport.deleteJSON(routes.reminder_path(refType, refId), {}, callback);
  }

  function snooze(refType, refId, callback) {
    transport.postJSON(routes.reminder_snooze_path(refType, refId), {}, callback);
  }

  return {
    update: update,
    destroy: destroy,
    snooze: snooze
  };

});



